import React from 'react';
import PortfoliosLibrary from './components/PortfoliosLibrary';

const PortfoliosPage = () => {
  return <PortfoliosLibrary />;
};

export default PortfoliosPage;
